import { render, staticRenderFns } from "./ProductDimensionsSizeUnit.vue?vue&type=template&id=46812d6a&"
import script from "./ProductDimensionsSizeUnit.vue?vue&type=script&lang=ts&"
export * from "./ProductDimensionsSizeUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports